// @flow
import React from 'react';
import { StatsItemsCard } from 'features/command-center/components/shared';
import strings from 'strings';

import { fakeFetchData } from './YearlyProductivityStatsSummary.utils';

export const YearlyProductivityStatsSummary = () => {
  return (
    <StatsItemsCard
      header={strings.commandCenter.teamGrowth.yearlyProductivityStatsSummary.title}
      promise={fakeFetchData}
      textAlign="center"
      subheader={strings.commandCenter.teamGrowth.yearlyProductivityStatsSummary.subtitle}
    />
  );
};
